import React, { lazy, memo, Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';

import { PermissionGuard } from './PermissionGuard';
import type { Routes } from '../../types';

const NotFound = lazy(() => import('../../routes/NotFound'));

type Props = { routes: Routes };

const Router: React.FC<Props> = ({ routes }: Props) => {
    return (
        <Suspense fallback={null}>
            <Switch>
                {routes.map((route) => {
                    const RouteComponent = route.component as React.ComponentType;
                    const Component =
                        (route.permission || route.permissionAny?.length) && RouteComponent
                            ? () => (
                                  <PermissionGuard
                                      permission={route.permission}
                                      permissionAny={route.permissionAny}
                                      Component={RouteComponent}
                                  />
                              )
                            : RouteComponent;

                    const key = route?.key || (route.path as string);
                    const routeProps = {
                        path: route.path,
                        location: route.location,
                        strict: route.strict,
                        exact: route.exact,
                        sensitive: route.sensitive
                    };
                    return route.render ? (
                        <Route key={key} render={route.render} {...routeProps} />
                    ) : (
                        <Route key={key} {...routeProps} component={Component} />
                    );
                })}
                <Route
                    render={() => (
                        <Suspense fallback={null}>
                            <NotFound />
                        </Suspense>
                    )}
                />
            </Switch>
        </Suspense>
    );
};

export default memo(Router);
